import { apiFetch } from './api';

const apiUrl = import.meta.env.VITE_API_URL;

/**
 * A tela de Mensagens da área Sistema (só GB Code).
 *
 * Todo valor em dinheiro daqui é ESTIMATIVA: a GB Code é parceira de soluções da
 * Meta, e a Meta omite o custo nos relatórios das contas faturadas pelo parceiro.
 * A tela tem que dizer isso — ver `tarifaVigenteEm`.
 *
 * docs/designsystem/propostas/admin/fase-5-mensagens.html §8.1
 */

export interface ConsumoTotais {
    faturaveis: number;
    custoEstimado: number;
    servicoAcimaDaCota: number;
    numerosAcimaDaCota: number;
    faturaveisProjetados: number | null;
    custoProjetado: number | null;
}

export interface ConsumoPorNumero {
    conexaoId: number | null;
    numero: string;
    empresaId: number;
    empresaNome: string;
    marketing: number;
    utilidade: number;
    autenticacao: number;
    servicoTotal: number;
    servicoNaCota: number;
    servicoAcimaDaCota: number;
    /** A cota do período — soma das cotas mensais quando o período cruza meses. */
    cotaDoPeriodo: number;
    faturaveis: number;
    custoEstimado: number;
}

export interface ConsumoResposta {
    totais: ConsumoTotais;
    numeros: ConsumoPorNumero[];
    tarifaVigenteEm: string | null;
    moeda: string;
    /** A mensagem de serviço já é cobrada? Até 30/09/2026 ela é grátis. */
    servicoCobrado: boolean;
    /** Quando ela passa a custar. Nulo se já custa. */
    servicoPassaACobrarEm: string | null;
    /** A cota grátis por número, mensal — vem da tabela de tarifas, não do código. */
    cotaMensalPorNumero: number;
    /** Nulo enquanto não houver nenhum dia coletado: é o que separa "zero" de "não medimos ainda". */
    medindoDesde: string | null;
}

export interface AtendimentoTotais {
    entraram: number;
    sairam: number;
    robo: number;
    pessoa: number;
    campanha: number;
    peloCelular: number;
}

export interface AtendimentoPorEmpresa {
    empresaId: number;
    empresaNome: string;
    entraram: number;
    sairam: number;
    robo: number;
    vendedorChat: number;
    vendedorCelular: number;
    campanha: number;
    automacao: number;
    percentualRobo: number;
}

export interface AtendimentoResposta {
    totais: AtendimentoTotais;
    empresas: AtendimentoPorEmpresa[];
    medindoDesde: string | null;
}

interface RespostaApi<T> {
    sucesso: boolean;
    mensagem: string;
    dados: T;
}

const buscar = async <T>(rota: string, de: string, ate: string): Promise<T> => {
    const res = await apiFetch(`${apiUrl}/api/sistema/mensagens/${rota}?de=${de}&ate=${ate}`);
    if (!res.ok) throw new Error(`Falha ao carregar ${rota} (${res.status})`);
    const corpo: RespostaApi<T> = await res.json();
    if (!corpo.sucesso) throw new Error(corpo.mensagem);
    return corpo.dados;
};

export const MensagensSistemaService = {
    consumo: (de: string, ate: string) => buscar<ConsumoResposta>('consumo', de, ate),
    atendimento: (de: string, ate: string) => buscar<AtendimentoResposta>('atendimento', de, ate),
};
